import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Observable, of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';

import {
  FetchListsForResource,
  FetchListsForResourceFailedAction,
  FetchListsForResourceSuccessAction,
  ListsForResourceActionTypes,
} from './lists-for-resource.actions';
import { ListsForResourceService } from './lists-for-resource.service';

@Injectable({ providedIn: 'root' })
export class ListsForResourceEffects {
  constructor(
    private actions$: Actions,
    private listsForResourceService: ListsForResourceService,
  ) {}

  fetchListsForResource$: Observable<
    | FetchListsForResource
    | FetchListsForResourceSuccessAction
    | FetchListsForResourceFailedAction
  > = createEffect(() =>
    this.actions$.pipe(
      ofType(ListsForResourceActionTypes.FETCH_LISTS_FOR_RESOURCE),
      mergeMap((action: FetchListsForResource) =>
        this.listsForResourceService
          .fetchListsForResource(action.payload.resourceId)
          .pipe(
            map(listsForResourceData => {
              return new FetchListsForResourceSuccessAction({
                listsForResourceData: listsForResourceData,
              });
            }),
            catchError(error =>
              of(
                new FetchListsForResourceFailedAction({
                  error,
                }),
              ),
            ),
          ),
      ),
    ),
  );
}
